import BaseService from 'services/BaseService';

export default class InternalDynamicAnchorService extends BaseService {
	_type = 'internalDynamicAnchor';
	_typeKey = 'type';
}
